import React from "react";
import { connect } from "react-redux";

import { activeFunderContactSelector } from "reducers";
import { URLS } from "../../constants";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Tab, TabGroup } from "../../components/Tabs";
import { setShouldSave } from "../../actions";
import BackToButton from "../../components/buttons/BackToButton";
import { ButtonSaveChanges } from "../../components/buttons";

const FunderDetailTopHeader = ({ ...props }) => {
  const { id } = useParams();
  const path = `/funder_contacts/${id}`;

  return (
    <div
      style={{
        position: "fixed",
        top: "4rem",
        left: "0rem",
        width: "100%",
        zIndex: 25,
      }}
    >
      <Card style={{ border: "1px solid black", borderRadius: "0px" }}>
        <Card.Header
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignContent: "center",
            backgroundColor: "black",
          }}
        >
          <h5
            className="section-title navbar-title"
            style={{
              color: "white",
              alignItems: "center",
              marginBottom: 0,
              lineHeight: 2,
              width: "30%",
            }}
          >
            Counter Party Contact: {props.displayName}
          </h5>
          <div style={{ display: "flex" }}>
            <BackToButton entity="Funders Contacts" url={URLS.FUNDER_CONTACTS} />;
            <ButtonSaveChanges saveFn={props.saveFn} />
          </div>
        </Card.Header>
      </Card>
      <h3 className={"header tertiary"}>
        <TabGroup
          style={{
            width: "100%",
          }}
        >
          <Tab link={`${path}/overview/`}>Counter Party Overview</Tab>
        </TabGroup>
      </h3>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  let funderInfo = activeFunderContactSelector(state);
  const displayName = funderInfo?.display_name ? funderInfo?.display_name : "";

  return {
    funderInfo,
    displayName,
  };
};

export default connect(mapStateToProps, {
  setShouldSave,
})(FunderDetailTopHeader);
